import { render, staticRenderFns } from "./ClearNotificationBlockedUsersPopup.vue?vue&type=template&id=380f0bf8&scoped=true&"
import script from "./ClearNotificationBlockedUsersPopup.vue?vue&type=script&lang=ts&"
export * from "./ClearNotificationBlockedUsersPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ClearNotificationBlockedUsersPopup.vue?vue&type=style&index=0&id=380f0bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f0bf8",
  null
  
)

export default component.exports